import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const BusinessChannelList = createSlice({
  name: "BusinessChannelList",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_business_channel: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_business_channel: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_business_channel: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    business_channel_is_first: (state, action) => {
      state.isFirst = false;
    },
  },
});
export default BusinessChannelList.reducer;
export const {
  list_business_channel,
  success_api_call_business_channel,
  failure_api_call_business_channel,
  business_channel_is_first,
} = BusinessChannelList.actions;
